import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { THs6pCode } from 'redux/reducers/taxDuties/types';

export const tableStructure: TTableStructure<keyof THs6pCode>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		key: true,
	},
	{
		name: 'HS6+ Code',
		selector: 'hs6pCode',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Description',
		selector: 'description',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 3,
		type: ETableStructureType.MULTILINE_TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated',
		selector: 'timestamp',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
];
